
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gzMZq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $cXtTj = parcelRequire("cXtTj");


var $ixfCV = parcelRequire("ixfCV");

const $2a83073b2ae5e0c1$export$6f57813fe9f31bf9 = (0, $8s9DV.createStore)({
    initialState: {
        editorContext: undefined,
        whiteboardContext: undefined,
        slidesContext: undefined,
        databaseContext: undefined,
        browserContext: undefined,
        dashboardContext: undefined,
        jiraWorkflowContext: undefined,
        aiFeatureContext: {},
        isAIFeatureContextDismissed: false,
        contentTargets: {},
        currentTargetId: undefined,
        pageSmartLinks: undefined
    },
    actions: {
        getAllContext: ()=>({ getState: getState })=>getState(),
        getAIFeatureContext: ()=>({ getState: getState })=>{
                const currentState = getState().aiFeatureContext;
                // Delete all properties that are undefined
                Object.keys(currentState).forEach((key)=>currentState[key] === undefined && delete currentState[key]);
                // Avoid sending an empty object
                return Object.keys(currentState).length ? currentState : undefined;
            },
        setAIFeatureContext: (chatContextData)=>({ getState: getState, setState: setState })=>{
                const state = getState();
                // Honour the user's explicit "Remove context" action
                if (state.isAIFeatureContextDismissed) return;
                const currentAIFeatureContextState = state.aiFeatureContext;
                const { contextKey: contextKey, setContext: setContext } = chatContextData;
                if (contextKey) {
                    const contextUpdated = setContext(currentAIFeatureContextState[contextKey]);
                    setState({
                        aiFeatureContext: {
                            ...currentAIFeatureContextState,
                            [contextKey]: contextUpdated
                        }
                    });
                }
            },
        setAIFeatureContextDismissed: (isDismissed)=>({ setState: setState })=>{
                setState(isDismissed ? {
                    aiFeatureContext: {},
                    isAIFeatureContextDismissed: true
                } : {
                    isAIFeatureContextDismissed: false
                });
            },
        getDashboardContext: ()=>({ getState: getState })=>getState().dashboardContext,
        setDashboardContext: (dashboardContext)=>({ setState: setState })=>{
                setState({
                    dashboardContext: dashboardContext
                });
            },
        getJiraWorkflowContext: ()=>({ getState: getState })=>getState().jiraWorkflowContext,
        setJiraWorkflowContext: (jiraWorkflowContext)=>({ setState: setState })=>{
                setState({
                    jiraWorkflowContext: jiraWorkflowContext
                });
            },
        getJiraCreateContext: ()=>({ getState: getState })=>getState().jiraCreateContext,
        setJiraCreateContext: (jiraCreateContext)=>({ setState: setState })=>{
                setState({
                    jiraCreateContext: jiraCreateContext
                });
            },
        getEditorContext: ()=>({ getState: getState })=>getState().editorContext,
        setEditorContext: (editorContext)=>({ setState: setState })=>{
                setState({
                    editorContext: editorContext
                });
            },
        updateEditorContextIsViewMode: (isViewMode)=>({ setState: setState, getState: getState })=>{
                const { editorContext: editorContext } = getState();
                if (editorContext) setState({
                    editorContext: {
                        ...editorContext,
                        isViewMode: isViewMode
                    }
                });
            },
        getWhiteboardContext: ()=>({ getState: getState })=>getState().whiteboardContext,
        setWhiteboardContext: (whiteboardContext)=>({ setState: setState })=>{
                setState({
                    whiteboardContext: whiteboardContext
                });
            },
        getSlidesContext: ()=>({ getState: getState })=>getState().slidesContext,
        setSlidesContext: (slidesContext)=>({ setState: setState })=>{
                setState({
                    slidesContext: slidesContext
                });
            },
        getDatabaseContext: ()=>({ getState: getState })=>getState().databaseContext,
        setDatabaseContext: (databaseContext)=>({ setState: setState })=>{
                setState({
                    databaseContext: databaseContext
                });
            },
        mergeDatabaseContext: (partial)=>({ getState: getState, setState: setState })=>{
                // If no selected elements published, clean up the database context
                if (!partial?.selectedElementIds) {
                    setState({
                        databaseContext: undefined
                    });
                    return;
                }
                const current = getState().databaseContext;
                setState({
                    databaseContext: current ? {
                        ...current,
                        ...partial
                    } : partial
                });
            },
        getBrowserContext: ()=>({ getState: getState })=>getState().browserContext,
        setBrowserContext: (browserContext)=>({ setState: setState })=>{
                setState({
                    browserContext: browserContext
                });
            },
        setPageSmartLinks: (pageSmartLinks)=>({ setState: setState })=>{
                setState({
                    pageSmartLinks: pageSmartLinks
                });
            },
        getTarget: (contentContext, activeTargetId)=>({ getState: getState })=>{
                const targets = getState().contentTargets[contentContext];
                if (!targets) return undefined;
                // targets is always an array
                const targetList = targets;
                // If activeTargetId provided, find it; otherwise return first target
                if (activeTargetId) return targetList.find((t)=>t.id === activeTargetId);
                return targetList[0];
            },
        getContentContext: (contentId)=>({ getState: getState })=>{
                const entries = Object.entries(getState().contentTargets);
                for (const [context, targets] of entries){
                    const targetList = targets;
                    if (targetList.some((t)=>t.id === contentId)) return context;
                }
                return undefined;
            },
        getActiveContext: ()=>({ getState: getState })=>{
                const entries = getState().contentTargets;
                // The rules here determine the 'rank' in which Rovo layers are resolved into "which layer is currently active".
                // They map to intended UX - in AIFC, the staging area is a modal-powered experience, on top of global experiences.
                // Consider the scenario of sending a message - the user will be interacting with the topmost layer.
                if (entries['staging-area']) return 'staging-area';
                return 'global';
            },
        hasTarget: (contentContext)=>({ getState: getState })=>!!getState().contentTargets[contentContext],
        setTarget: (toAdd, target)=>({ getState: getState, setState: setState })=>{
                const currentTargets = getState().contentTargets;
                // Store as array, append if not already present
                const existing = currentTargets[toAdd];
                const targetList = existing ?? [];
                // Avoid duplicates by checking if target with same id exists
                // & filter out any targets with empty IDs to avoid stale targets
                const filtered = targetList.filter((t)=>t.id !== '' && t.id !== target.id);
                filtered.push(target);
                setState({
                    contentTargets: {
                        ...currentTargets,
                        [toAdd]: filtered
                    }
                });
            },
        clearTarget: (toRemove, targetId)=>({ getState: getState, setState: setState })=>{
                const currentState = getState().contentTargets;
                const nextState = {};
                for (const key of Object.keys(currentState)){
                    const k = key;
                    if (k !== toRemove) nextState[k] = currentState[k];
                    else if (targetId) {
                        // If a specific targetId is provided, filter out that target
                        const targetList = currentState[k];
                        const filtered = targetList.filter((t)=>t.id !== targetId);
                        if (filtered.length > 0) nextState[k] = filtered;
                    }
                }
                setState({
                    contentTargets: nextState
                });
            },
        setCurrentTargetId: (targetId)=>({ setState: setState })=>{
                setState({
                    currentTargetId: targetId
                });
            },
        getCurrentTargetId: ()=>({ getState: getState })=>getState().currentTargetId
    }
});
const $2a83073b2ae5e0c1$export$53bf948a400e8426 = (0, $kBr4q.createActionsHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9);
const $2a83073b2ae5e0c1$export$9465f65715425f1b = (0, $kBr4q.createHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.editorContext
});
const $2a83073b2ae5e0c1$export$eea520981851a092 = (0, $kBr4q.createHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.whiteboardContext
});
const $2a83073b2ae5e0c1$export$c517e9a5e436c401 = (0, $kBr4q.createHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.slidesContext
});
const $2a83073b2ae5e0c1$export$debe3dc2612d2a8e = (0, $kBr4q.createHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.databaseContext
});
const $2a83073b2ae5e0c1$export$376b2a7bf70dad8 = (0, $kBr4q.createHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.browserContext
});
const $2a83073b2ae5e0c1$export$6280f21050465fe4 = (0, $kBr4q.createHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.pageSmartLinks
});
const $2a83073b2ae5e0c1$export$3794ec8d9f571031 = (0, $kBr4q.createHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.aiFeatureContext
});
const $2a83073b2ae5e0c1$export$904052abb7b98535 = ({ requestBrowserContent: requestBrowserContent, getContentBody: getContentBody, getStagingSpace: getStagingSpace, useCurrentNonEditingPageAsContext: useCurrentNonEditingPageAsContext, requestJiraContext: requestJiraContext })=>{
    const actions = $2a83073b2ae5e0c1$export$53bf948a400e8426();
    const { getTarget: getTarget, getCurrentTargetId: getCurrentTargetId } = actions;
    const fetchContent = (0, $cozmU.useCallback)(async (type, contentContext, activeTargetId)=>{
        const currentTargetId = getCurrentTargetId();
        const contentTarget = getTarget(contentContext, activeTargetId);
        if (!contentTarget) return undefined;
        // Only use currentTargetId when staging-area doesn't exist
        // to avoid changing any content open behind the staging
        // area modal
        const shouldUseCurrentTargetId = type === 'page' && !getTarget('staging-area');
        const selectedTargetId = shouldUseCurrentTargetId ? currentTargetId || contentTarget.id : contentTarget.id;
        const contentBody = await getContentBody(type, selectedTargetId);
        if (!contentBody || contentBody.contentType !== type) return undefined;
        switch(contentBody.contentType){
            case 'page':
                if (!contentBody.pageBody) return undefined;
                return {
                    contentId: contentBody.contentId,
                    editorStreamingContractVersion: contentBody.editorStreamingContractVersion,
                    document: {
                        type: 'text/adf',
                        content: contentBody.pageBody
                    },
                    selection: {
                        type: 'text/markdown',
                        content: contentBody.selectionMarkdown || ''
                    },
                    selectionFragment: contentBody.selectionFragment,
                    selectionLocalIds: contentBody.selectionLocalIds,
                    contentMauiId: contentBody.contentMauiId,
                    dynamicUiSource: contentBody.dynamicUiSource,
                    dynamicUiType: contentBody.dynamicUiType,
                    mediaFileId: contentBody.mediaFileId,
                    isViewMode: contentBody.isViewMode,
                    isDraftLockedForEditing: contentBody.isDraftLockedForEditing,
                    useGenericEditorSkill: contentBody.useGenericEditorSkill,
                    additionalContext: contentBody.additionalContext
                };
            case 'whiteboard':
                if (!contentBody.svg || !contentBody.wdf) return undefined;
                return {
                    contentId: contentBody.contentId,
                    type: 'image/svg+xml',
                    svg: contentBody.svg,
                    title: contentBody.title ?? null,
                    url: contentBody.url ?? null,
                    wdf: contentBody.wdf,
                    selectedElementIds: contentBody.selectedElementIds,
                    isViewMode: contentBody.isViewMode
                };
            case 'slide':
                if (!contentBody.xml) return undefined;
                return {
                    contentId: contentBody.contentId,
                    xml: contentBody.xml,
                    title: contentBody.title,
                    url: contentBody.url,
                    selectedSlideIndex: contentBody.selectedSlideIndex,
                    selectedElementIds: contentBody.selectedElementIds,
                    isViewMode: contentBody.isViewMode
                };
            case 'database':
                if (!contentBody.csv) return undefined;
                return {
                    contentId: contentBody.contentId,
                    csv: contentBody.csv,
                    title: contentBody.title,
                    url: contentBody.url,
                    isViewMode: contentBody.isViewMode
                };
            case 'dashboard':
                if (!contentBody.content) return undefined;
                return {
                    content: contentBody.content,
                    dashboardAri: contentBody.dashboardAri,
                    isEditing: contentBody.isEditing,
                    chartResponseData: contentBody.chartResponseData
                };
            default:
                return undefined;
        }
    }, [
        getContentBody,
        getTarget,
        getCurrentTargetId
    ]);
    /**
   * Fetches the context of a currently live page with Rovo chat open.
   *
   * @description see full list of cases to consider in {@link getContextRequirements}
   */ const getEditorContext = (0, $cozmU.useCallback)(async ({ source: source, contentContext: contentContext_0, isFirstPrompt: isFirstPrompt, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, activeTargetId: activeTargetId_0 })=>{
        const isAifcEnabled = (0, $ixfCV.fg)('aifc_create_enabled');
        const shouldProvideContext = $2a83073b2ae5e0c1$export$86d7678a1db25436({
            contentContext: contentContext_0,
            source: source,
            isFirstPrompt: isFirstPrompt,
            isAifcEnabled: isAifcEnabled,
            userPreference: addCurrentPageAsContextUserPreference
        });
        if (!shouldProvideContext) return undefined;
        return isAifcEnabled ? await fetchContent('page', contentContext_0, activeTargetId_0) : actions.getEditorContext();
    }, [
        actions,
        fetchContent
    ]);
    /**
   * Fetches the context of a currently live page with Rovo chat open.
   *
   * @description see full list of cases to consider in {@link getContextRequirements}
   */ const getWhiteboardContext = (0, $cozmU.useCallback)(async ({ source: source_0, contentContext: contentContext_1, isFirstPrompt: isFirstPrompt_0, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference_0, activeTargetId: activeTargetId_1 })=>{
        const isAifcEnabled_0 = (0, $ixfCV.fg)('aifc_create_enabled');
        const shouldProvideContext_0 = $2a83073b2ae5e0c1$export$86d7678a1db25436({
            contentContext: contentContext_1,
            source: source_0,
            isFirstPrompt: isFirstPrompt_0,
            isAifcEnabled: isAifcEnabled_0,
            userPreference: addCurrentPageAsContextUserPreference_0
        });
        if (!shouldProvideContext_0) return undefined;
        return isAifcEnabled_0 ? await fetchContent('whiteboard', contentContext_1, activeTargetId_1) : actions.getWhiteboardContext();
    }, [
        actions,
        fetchContent
    ]);
    const getSlidesContext = (0, $cozmU.useCallback)(async ({ source: source_1, contentContext: contentContext_2, isFirstPrompt: isFirstPrompt_1, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference_1, activeTargetId: activeTargetId_2 })=>{
        const isAifcEnabled_1 = (0, $cXtTj.default).getExperimentValue('cc-mui-slides-experiment', 'isEnabled', false);
        const shouldProvideContext_1 = $2a83073b2ae5e0c1$export$86d7678a1db25436({
            contentContext: contentContext_2,
            source: source_1,
            isFirstPrompt: isFirstPrompt_1,
            isAifcEnabled: isAifcEnabled_1,
            userPreference: addCurrentPageAsContextUserPreference_1
        });
        if (!shouldProvideContext_1) return undefined;
        return isAifcEnabled_1 ? await fetchContent('slide', contentContext_2, activeTargetId_2) : actions.getSlidesContext();
    }, [
        actions,
        fetchContent
    ]);
    const getDatabaseContext = (0, $cozmU.useCallback)(async ({ source: source_2, contentContext: contentContext_3, isFirstPrompt: isFirstPrompt_2, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference_2, activeTargetId: activeTargetId_3 })=>{
        const isAifcEnabled_2 = (0, $ixfCV.fg)('aifc_create_enabled');
        const shouldProvideContext_2 = $2a83073b2ae5e0c1$export$86d7678a1db25436({
            contentContext: contentContext_3,
            source: source_2,
            isFirstPrompt: isFirstPrompt_2,
            isAifcEnabled: isAifcEnabled_2,
            userPreference: addCurrentPageAsContextUserPreference_2
        });
        if (!shouldProvideContext_2) return undefined;
        return isAifcEnabled_2 ? await fetchContent('database', contentContext_3, activeTargetId_3) : actions.getDatabaseContext();
    }, [
        actions,
        fetchContent
    ]);
    const getDashboardEditorContext = (0, $cozmU.useCallback)(async ({ contentContext: contentContext_4, activeTargetId: activeTargetId_4 })=>{
        if (!(0, $ixfCV.fg)('platform_avp_aifc_enabled')) return undefined;
        return await fetchContent('dashboard', contentContext_4, activeTargetId_4);
    }, [
        fetchContent
    ]);
    const getSpaceCreateContext = (0, $cozmU.useCallback)(({ contentContext: contentContext_5, isFirstPrompt: isFirstPrompt_3 })=>{
        if (contentContext_5 === 'staging-area' && !isFirstPrompt_3 && (0, $ixfCV.fg)('aifc_space_creation_enabled')) return getStagingSpace(String(getTarget(contentContext_5)?.id));
    }, [
        getStagingSpace,
        getTarget
    ]);
    const getIsStagingArea = (0, $cozmU.useCallback)(()=>actions.getActiveContext() === 'staging-area', [
        actions
    ]);
    const useCurrentBrowsingContext = (0, $cozmU.useCallback)((addCurrentPageAsContextUserPreference_3)=>{
        // If the user has explicitly turned off "use current page as context" (e.g.
        // by dismissing the context banner), send false rather than undefined so the
        // backend is explicitly told not to use the browserUrl as context. This is
        // required in edit mode, where useCurrentNonEditingPageAsContext is undefined
        // but the user preference is set to false on dismiss. the value is sent as true
        // when the context is enabled in the chat banner.
        if (addCurrentPageAsContextUserPreference_3) return addCurrentPageAsContextUserPreference_3;
        // undefined means don't send useCurrentBrowsingContext at all. false tells backend to explicitly not use the browserUrl as context.
        if (useCurrentNonEditingPageAsContext === undefined) return undefined;
        const stagingAreaEnabled = getIsStagingArea();
        return !stagingAreaEnabled && addCurrentPageAsContextUserPreference_3 && useCurrentNonEditingPageAsContext;
    }, [
        useCurrentNonEditingPageAsContext,
        getIsStagingArea
    ]);
    const getBrowserContext = (0, $cozmU.useCallback)(async ({ addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference_4, enabled: enabled })=>{
        // if the feature is not enabled, we return the original context resolution.
        if (!enabled && !(0, $cXtTj.default).getExperimentValue('jira_free_gen_editor', 'isEnabled', false)) return actions.getBrowserContext();
        if (!addCurrentPageAsContextUserPreference_4) return undefined;
        // Request browser content from the extension
        const browserContextResult = await requestBrowserContent();
        const browserContext = browserContextResult ? {
            context: browserContextResult
        } : actions.getBrowserContext();
        return browserContext;
    }, [
        requestBrowserContent,
        actions
    ]);
    const getJiraContext = (0, $cozmU.useCallback)(async ()=>{
        const isStagingArea = getIsStagingArea();
        if (!isStagingArea) {
            const jiraCreateContext = actions.getJiraCreateContext();
            if (jiraCreateContext?.draftWorkItems) return jiraCreateContext;
        }
        // Fallback to bridge API if available (staging area doesn't have the state in sync with the chat store)
        if (!requestJiraContext) return undefined;
        try {
            const result = await requestJiraContext();
            return result?.success ? result.context : undefined;
        // eslint-disable-next-line no-unused-vars
        } catch (error) {
            return undefined;
        }
    }, [
        requestJiraContext,
        actions,
        getIsStagingArea
    ]);
    return {
        ...actions,
        getEditorContext: getEditorContext,
        getWhiteboardContext: getWhiteboardContext,
        getSlidesContext: getSlidesContext,
        getSpaceCreateContext: getSpaceCreateContext,
        getIsStagingArea: getIsStagingArea,
        useCurrentBrowsingContext: useCurrentBrowsingContext,
        getDatabaseContext: getDatabaseContext,
        getDashboardEditorContext: getDashboardEditorContext,
        getBrowserContext: getBrowserContext,
        getJiraContext: getJiraContext
    };
};
function $2a83073b2ae5e0c1$export$86d7678a1db25436({ contentContext: contentContext, source: source, isFirstPrompt: isFirstPrompt, isAifcEnabled: isAifcEnabled, userPreference: userPreference }) {
    /**
   * If AIFC is not enabled, we default to the user's preference.
   */ if (!isAifcEnabled) return userPreference;
    /**
   * In the staging area, we always want to provide context if the source is the
   * inline editor, from the blank object experience, or if the prompt is not the
   * first in a new conversation.
   */ const sourceEligible = source === 'CONFLUENCE_INLINE_EDITOR' || source === 'INLINE_EDITOR' || source === 'CONFLUENCE_MAUI_INLINE_EDITOR' || source === 'CONFLUENCE_WHITEBOARD_TO_PAGE_BUTTON' || source === 'CONFLUENCE_WHITEBOARD_BRAINSTORMING_FOLLOW_UP' || source === 'CONFLUENCE_CWR_TEMPLATE' || source === 'CONFLUENCE_CWR_BLANK_OBJECT';
    if (contentContext === 'staging-area') return sourceEligible || !isFirstPrompt;
    else /**
     * On real content when AIFC is enabled, we only want to default to true
     * if the source of the content is the inline editing experience. Otherwise,
     * we want to respect the preference chosen by the user.
     */ return sourceEligible || userPreference;
}
module.exports["useChatContextStoreActions"] = $2a83073b2ae5e0c1$export$53bf948a400e8426;
module.exports["useChatContextEditorContext"] = $2a83073b2ae5e0c1$export$9465f65715425f1b;
module.exports["useChatContextDatabaseContext"] = $2a83073b2ae5e0c1$export$debe3dc2612d2a8e;
module.exports["useChatContextBrowserContext"] = $2a83073b2ae5e0c1$export$376b2a7bf70dad8;
module.exports["useChatContextPageSmartLinks"] = $2a83073b2ae5e0c1$export$6280f21050465fe4;
module.exports["useChatContextAIFeatureContext"] = $2a83073b2ae5e0c1$export$3794ec8d9f571031;
module.exports["useChatContextProvider"] = $2a83073b2ae5e0c1$export$904052abb7b98535;

});


//# sourceMappingURL=UpdateComposer.490854c7.js.map
